import { BASIC_QUESTIONS } from './basic-questions';
import { MATH_QUEST_1_QUESTIONS } from './math-quest-1';
import { MATH_QUEST_2_QUESTIONS } from './math-quest-2';
import { MATH_QUEST_3_QUESTIONS } from './math-quest-3';
import { MATH_QUEST_4_QUESTIONS } from './math-quest-4';

export const QUESTIONS = [
  ...BASIC_QUESTIONS,
  ...MATH_QUEST_1_QUESTIONS,
  ...MATH_QUEST_2_QUESTIONS,
  ...MATH_QUEST_3_QUESTIONS,
  ...MATH_QUEST_4_QUESTIONS,
];

export { COLORS } from './colors';
export { TEST_HEX_COLORS } from './colors';
